import { createContext, useContext } from "react";

import { ScrollState, useScrollDirection } from "@/hooks/useScrollDirection";
import { FCC } from "@/types";

const defaultState: ScrollState = { direction: "up", atTop: true };

export const ScrollDirectionContext = createContext<ScrollState>(defaultState);

interface ScrollDirectionProviderProps {
  enabled?: boolean;
}

// Single shared scroll listener for any UI that reacts to scroll position
// (mobile header, bottom nav bar, ...) instead of each consumer registering its own.
export const ScrollDirectionProvider: FCC<ScrollDirectionProviderProps> = ({
  enabled = true,
  children,
}) => {
  const state = useScrollDirection(enabled);

  return (
    <ScrollDirectionContext.Provider value={state}>
      {children}
    </ScrollDirectionContext.Provider>
  );
};

export const useScrollDirectionContext = (): ScrollState =>
  useContext(ScrollDirectionContext);
